import { render, staticRenderFns } from "./MainOrder.vue?vue&type=template&id=61964547&"
import script from "./MainOrder.vue?vue&type=script&lang=js&"
export * from "./MainOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports